const weatherIconMap = {
    '0': 'fluent:weather-sunny-28-regular',
    '1': 'mdi:weather-partly-cloudy',
    '2': 'mdi:weather-partly-cloudy',
    '3': 'mdi:weather-partly-cloudy',
    '45': 'mdi:weather-fog',
    '48': 'mdi:weather-fog',
    '51': 'fluent:weather-drizzle-20-regular',
    '53': 'fluent:weather-drizzle-20-regular',
    '55': 'fluent:weather-drizzle-20-regular',
    '56': 'fluent:weather-rain-snow-48-filled',
    '57': 'fluent:weather-rain-snow-48-filled',
    '61': 'fluent:weather-rain-24-regular',
    '63': 'fluent:weather-rain-24-regular',
    '65': 'fluent:weather-rain-24-regular',
    '66': 'fluent:weather-shower',
    '67': 'fluent:weather-shower',
    '71': 'fluent:weather-snow-20-regular',
    '73': 'fluent:weather-snow-20-regular',
    '75': 'fluent:weather-snow-20-regular',
    '77': 'fluent:weather-snow-20-regular',
    '80': 'carbon:rain-drizzle',
    '81': 'carbon:rain',
    '82': 'carbon:rain-heavy',
}


export default weatherIconMap;